module.exports = __webpack_public_path__ + "static/media/caba-logo.1a772e6d.svg";